// Imports
import React, { useEffect } from "react";
import PropTypes from "prop-types";

// UI Imports

import Logo from "./header/images/logo.svg";

// App Imports
import Header from "./header/Header";
import ContainerFluid from "./../../ui/ContainerFluid";

const Layout = (props) => {
  const { children } = props;

  // const isMaintenance = window.localStorage.getItem("maintenance");

  // useEffect(() => {
  //   const isMaintenance = new URLSearchParams(window.location.search).get(
  //     "maintenance"
  //   );
  //   if (isMaintenance) {
  //     window.localStorage.setItem("maintenance", "true");
  //     window.location.href = "/";
  //   }
  // })

  // if (!isMaintenance) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         minHeight: "100vh",
  //       }}
  //     >
  //       <img
  //         style={{ width: 100, height: "auto", marginBottom: 20 }}
  //         src={Logo}
  //         alt="logo"
  //       />
  //       <div
  //         style={{
  //           textAlign: "center",
  //           marginBottom: 30,
  //           fontSize: 24,
  //           color: "#0daea5",
  //         }}
  //       >
  //         La Ressourcerie
  //       </div>
  //       <div
  //         style={{
  //           textAlign: "center",
  //         }}
  //       >
  //         Le site est momentanément indisponible.
  //         <br />
  //         Veuillez nous excuser pour la gène occassionnée.
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <>
      {/* Header */}
      <Header />

      {/* Page Content */}
      <div className="page-content">
        <ContainerFluid>{children}</ContainerFluid>
      </div>
    </>
  );
};

// Component Properties
Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
